import { z } from 'zod';

const abiDetails = z.object({
  found: z.boolean(),
  verified: z.boolean(),
  abi: z.array(z.any()),
});

const sourceCodeDetails = z.object({
  found: z.boolean(),
  verified: z.boolean(),
  sourceCode: z.union(z.string(), z.null()),
});

const bytecodeDetails = z.object({
  found: z.boolean(),
  bytecode: z.string(),
  verified: z.boolean(),
});

const standardDetails = z.object({
  standard: z.string(),
  matchedEvents: z.array(z.string()),
  matchedFunctions: z.array(z.string()),
  requiredFunctions: z.array(z.string()),
  requiredEvents: z.array(z.string()),
  metadata: z.object({
    source: z.string(),
  }),
});

const contractBreakdownOverviewSchema = z.object({
  standards: z.array(standardDetails),
  abi: abiDetails,
  sourceCode: sourceCodeDetails,
  bytecode: bytecodeDetails,
});

export default { contractBreakdownOverviewSchema };
